module.exports = __webpack_public_path__ + "494cd07c/img/question-icon.06c20c5d.svg";